import styled from 'styled-components'
import { isColor, rem, themeColor } from '~theme'
import { IconStyled } from '~components/Icon'
import { LoaderColor } from './Loader.types'

interface ContainerProps {
  size: number
  color: LoaderColor
}

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div<ContainerProps>`
  display: inline-flex;
  flex-shrink: 0;
  // Looks a little bit weird, but we have to check the type of color here to match 'themeColor' overloads
  color: ${({ color }) => (isColor(color) ? themeColor(color) : themeColor(color))};

  &,
  ${IconStyled} {
    width: ${({ size }) => rem(size)};
    height: ${({ size }) => rem(size)};
  }
`
